import React from 'react';
import './WelcomeModal.css';

interface Props {
  onDismiss: () => void;
  isPreview?: boolean;
}

export default function WelcomeModal({ onDismiss, isPreview = false }: Props) {
  return (
    <div className="welcome-backdrop">
      <div className="welcome-modal" role="dialog" aria-modal="true" aria-labelledby="welcome-title">

        <div className="welcome-logo-wrap">
          <svg className="welcome-logo" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <rect width="32" height="32" rx="6" fill="#1a1a2e"/>
            <path d="M16 3 L5 7.5 L5 18 C5 24.5 10 29 16 31 C22 29 27 24.5 27 18 L27 7.5 Z" fill="#a0785a"/>
            <polygon points="16,9 11.5,14 13.5,14 10,19.5 13.5,19.5 13.5,23 18.5,23 18.5,19.5 22,19.5 18.5,14 20.5,14" fill="#f8f7f4"/>
          </svg>
        </div>

        <h2 id="welcome-title" className="welcome-title">Welcome to Your Cedar Vault</h2>

        <p className="welcome-body">
          You've done something most people never do — you've taken the first step toward making
          things easier for the people you love. This is your private, secure vault for everything
          your family will need when they need it most.
        </p>

        <p className="welcome-body">
          Your <strong>Getting Started</strong> checklist is waiting just below. Begin with two
          things that take less than five minutes: record your <strong>phone and computer logins</strong>{' '}
          — your family will need them in the first 48 hours — and leave a{' '}
          <strong>Legacy Message</strong>: write a sealed letter or record a video message. House keys,
          car keys, the checkbook, the safe — or just your face and your voice, saying what needs to be said.
          Small things. An enormous difference.
        </p>

        {isPreview && (
          <p className="welcome-preview-notice">
            Admin preview — this modal appears once for new vault owners.
          </p>
        )}

        <button className="welcome-cta" onClick={onDismiss}>
          {isPreview ? 'Close Preview' : 'Let\'s Get Started →'}
        </button>

      </div>
    </div>
  );
}
